module.exports = __webpack_public_path__ + "static/media/icon_close_simple.c769f8cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_close_simple.png
// module id = 253
// module chunks = 0